export default __webpack_public_path__ + "static/media/forest.3d913f97.png";